import { useMemo } from 'react'
import SortOptionTransport from '../../../transports/common/sort-option-transport'
import { useSelector } from 'react-redux'
import { getSortOptions } from '../../../redux/filters/selectors'

const DEFAULT_SORT_LABEL = 'sort-default'

interface ActiveSortInfo {
    activeSortOption: SortOptionTransport | undefined
    isNonDefaultSortActive: boolean
}

export const useActiveSortOption = (): ActiveSortInfo => {
    const sortOptions = useSelector(getSortOptions)

    return useMemo(() => {
        const activeSortOption = sortOptions?.find(option => option.isActive)
        const isNonDefaultSortActive = !!activeSortOption && activeSortOption.label !== DEFAULT_SORT_LABEL

        return {
            activeSortOption,
            isNonDefaultSortActive,
        }
    }, [sortOptions])
}
